<ng-container>
  <c-toast-header [closeButton]="closeButton">
    <svg
      [cIcon]="status ? icons.cilCheckCircle : icons.cilWarning"
      size="md"
      title="Icon"
      style="margin-right: 10px"
    ></svg>
    <strong>{{ title }}</strong>
  </c-toast-header>
  <c-toast-body #toastBody [cToastClose]="toastBody.toast">
    <p class="mb-1 text-white">{{ description }}</p>
    <ng-content />
    <!-- <c-progress thin [value]="25*(toastBody.toast?.clock ?? 1)" /> -->
  </c-toast-body>
</ng-container>
